import { createContext, useContext } from 'react';

export type ContainerLayout = 'slider' | 'wrapper';

const ContainerLayoutContext = createContext<ContainerLayout | null>(null);

export const ContainerLayoutProvider = ContainerLayoutContext.Provider;

export const useContainerLayout = () => useContext(ContainerLayoutContext);
